import { IApproveSuggestedFaqDTO, TApproveSuggestedFaqInput } from '@/models/suggestedFaq.model';

type TApproveSuggestedFaqParams = TApproveSuggestedFaqInput & { reviewId: string };

class ApproveSuggestedFaqDTO implements IApproveSuggestedFaqDTO {
  reviewId: string;

  question?: string;

  answer: string;

  isGeneral: boolean;

  channelIds?: number[];

  constructor({ reviewId, question, originalQuestion, answer, isGeneral, channelIds }: TApproveSuggestedFaqParams) {
    this.reviewId = reviewId;
    this.answer = answer;
    this.isGeneral = isGeneral;

    if (question !== originalQuestion) {
      this.question = question;
    }

    if (!isGeneral) {
      this.channelIds = channelIds ?? [];
    }
  }
}

export default ApproveSuggestedFaqDTO;
